export default __webpack_public_path__ + "static/media/Guy.b70d9b3c.png";